import StateType from './state.type';

export default {
  loading: false,
  loadingSave: false,
  mappings: [],
  types: [],
} as StateType;
